export const reds = [
  "🛑",
  "🍒",
  "🍓",
  "🍉",
  "🍅",
  "🌹",
  "🥀",
  "🏮",
  "🌶",
  "💄",
  "🧨",
  "🧧",
  "💋",
  "🥊",
  "🐞",
  "🔻",
  "😡",
  "🩸",
  "⭕",
  "🩸",
  "🍷",
  "👹",
  "👺",
  "🍎",
  "🎀",
];
export const greens = [
  "🦖",
  "🦕",
  "🦎",
  "🐊",
  "🐢",
  "🫑",
  "🦚",
  "🐲",
  "🌴",
  "🐍",
  "🥑",
  "🥬",
  "🐉",
  "🦜",
  "🐸",
  "🍀",
  "🌳",
  "🌱",
  "💚",
  "🟢",
  "🌿",
  "🟩",
  "🍃",
  "🍏",
  "📗",
  "🌵",
  "🥝",
  "🥦",
  "🐛",
  "🎋",
  "🌲",
  "🥗",
  "🥒",
];
export const blues = [
  "🌊",
  "💎",
  "💙",
  "🐳",
  "🧊",
  "🔵",
  "🌀",
  "🧿",
  "🦋",
  "🔷",
  "🥶",
  "💤",
  "💧",
  "🧢",
];
export const possibleEmoji = [
  "😀",
  "😃",
  "😄",
  "😁",
  "😆",
  "😅",
  "😂",
  "🤣",
  "🥲",
  "😊",
  "😇",
  "🙂",
  "🙃",
  "😉",
  "😌",
  "😍",
  "🥰",
  "😘",
  "😗",
  "😙",
  "😚",
  "😋",
  "😛",
  "😝",
  "😜",
  "🤪",
  "🤨",
  "🧐",
  "🤓",
  "😎",
  "🥸",
  "🤩",
  "🥳",
  "😏",
  "😒",
  "😞",
  "😔",
  "😟",
  "😕",
  "🙁",
  "😣",
  "😖",
  "😫",
  "😩",
  "🥺",
  "😢",
  "😭",
  "😤",
  "😠",
  "🤯",
  "😥",
  "😓",
  "🤗",
  "🤔",
  "🤭",
  "🤫",
  "🤥",
  "😶",
  "😐",
  "😑",
  "😬",
  "🙄",
  "😯",
  "😦",
  "😧",
  "😮",
  "😲",
  "🥱",
  "😴",
  "🤤",
  "😪",
  "😵",
  "🤐",
  "🥴",
  "🤧",
  "😷",
  "🤒",
  "🤕",
  "🤑",
  "🤠",
  "😺",
  "😸",
  "😹",
  "😻",
  "😼",
  "😽",
  "🙀",
  "😿",
  "😾",
];
export const hands = [
  "👋",
  "👍",
  "👎",
  "👊",
  "✊",
  "🤛",
  "🤜",
  "🤞",
  "🤟",
  "🤘",
  "👌",
  "👈",
  "👉",
  "👆",
  "👇",
  "✋",
  "🤚",
  "🖐",
  "🖖",
  "👋",
  "👍",
  "👎",
  "👊",
  "✊",
  "🤛",
  "🤜",
  "🤞",
  "🤟",
  "🤘",
  "👌",
  "👈",
  "👉",
  "👆",
  "👇",
  "✋",
  "🤚",
  "🖐",
  "🖖",
  "👋",
  "👍",
  "👎",
  "👊",
  "✊",
  "🤛",
  "🤜",
  "🤞",
  "🤟",
  "🤘",
  "👌",
  "👈",
  "👉",
  "👆",
  "👇",
  "✋",
  "🤚",
  "🖐",
  "🖖",
  "👋",
  "👍",
  "👎",
  "👊",
  "✊",
  "🤛",
  "🤜",
  "🤞",
  "🤟",
  "🤘",
  "👌",
  "👈",
  "👉",
  "👆",
  "👇",
  "✋",
  "🤚",
  "🖐",
  "🖖",
  "👋",
  "👍",
  "👎",
  "👊",
  "✊",
  "🤛",
  "🤜",
  "🤞",
  "🤟",
  "🤘",
  "👌",
  "👈",
  "👉",
  "👆",
  "👇",
  "✋",
  "🤚",
  "🖐",
  "🖖",
  "👋",
  "👍",
  "👎",
  "👊",
  "✊",
  "🤛",
  "🤜",
  "🤞",
  "🤟",
  "🤘",
  "👌",
  "👈",
  "👉",
  "👆",
  "👇",
  "✋",
  "🤚",
  "🖐",
];
export const flags = [
  "🇦🇺",
  "🇦🇹",
  "🇦🇿",
  "🇧🇪",
  "🇧🇷",
  "🇧🇬",
  "🇧🇫",
  "🇧🇮",
  "🇧🇯",
  "🇧🇲",
  "🇧🇹",
  "🇧🇴",
  "🇧🇦",
  "🇧🇼",
  "🇧🇷",
  "🇨🇦",
  "🇨🇱",
  "🇨🇳",
  "🇨🇴",
  "🇨🇫",
  "🇨🇩",
  "🇨🇷",
  "🇨🇺",
  "🇨🇼",
  "🇨🇾",
  "🇨🇿",
  "🇩🇰",
  "🇩🇯",
  "🇩🇲",
  "🇩🇴",
  "🇩🇪",
  "🇩🇮",
  "🇩🇬",
  "🇩🇰",
  "🇩🇯",
  "🇩🇲",
  "🇩🇴",
  "🇩🇪",
  "🇩🇮",
  "🇩🇬",
  "🇪🇨",
  "🇪🇬",
  "🇪🇷",
  "🇪🇪",
  "🇪🇹",
  "🇪🇺",
  "🇫🇰",
  "🇫🇴",
  "🇫🇯",
  "🇫🇮",
  "🇫🇷",
  "🇬🇦",
  "🇬🇲",
  "🇬🇪",
  "🇬🇭",
  "🇬🇮",
  "🇬🇷",
  "🇬🇱",
  "🇬🇩",
  "🇬🇵",
  "🇬🇺",
  "🇬🇹",
];
export const fruits = [
  "🍑",
  "🍐",
  "🍊",
  "🍋",
  "🍌",
  "🍉",
  "🍇",
  "🍓",
  "🍈",
  "🍒",
];
export const animals = [
  "🐶",
  "🐱",
  "🐭",
  "🐹",
  "🐰",
  "🐻",
  "🐼",
  "🐨",
  "🐯",
  "🦁",
  "🐮",
  "🐷",
  "🐸",
  "🐵",
  "🙈",
  "🙉",
  "🙊",
  "🐒",
  "🐔",
  "🐧",
  "🐦",
  "🐤",
  "🐣",
  "🐥",
  "🦆",
  "🦅",
  "🦉",
  "🦇",
  "🐺",
  "🐗",
  "🐴",
  "🦄",
  "🐝",
  "🐛",
  "🦋",
  "🐌",
  "🐚",
  "🐞",
  "🐜",
  "🦗",
  "🕷",
  "🕸",
  "🦂",
  "🐢",
  "🐍",
  "🦎",
  "🦖",
  "🦕",
  "🐙",
  "🦑",
  "🦐",
  "🦀",
  "🐡",
  "🐠",
  "🐟",
  "🐬",
  "🐳",
  "🐋",
  "🦈",
  "🐊",
  "🐅",
  "🐆",
  "🦓",
  "🦍",
  "🐘",
  "🦏",
  "🦛",
  "🦏",
  "🐪",
  "🐫",
  "🦒",
  "🦘",
  "🦡",
  "🐃",
  "🐂",
  "🐄",
  "🐎",
  "🐖",
  "🐏",
  "🐑",
  "🐐",
  "🦌",
  "🐕",
  "🐩",
  "🐈",
  "🐓",
  "🦃",
  "🕊",
  "🐇",
  "🐁",
  "🐀",
  "🐿",
  "🦔",
  "🐾",
  "🐉",
  "🐲",
];
export const ekraineFlag = ["🇺🇦", "🇷🇺"];
